export const UserStatus = {
    CONFIRMED: 'CONFIRMED',
    FORCEPASS: 'FORCE_CHANGE_PASSWORD'
}